/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBellRingFill: {
  name: 'bell-ring-fill';
  data: string;
} = {
  name: 'bell-ring-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.707 2.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414l3-3Zm8.586-1.414a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414ZM5 10a7 7 0 0 1 14 0v4.697l.796 1.194C20.682 17.22 19.729 19 18.13 19H16a4 4 0 0 1-8 0H5.869c-1.598 0-2.55-1.78-1.665-3.11L5 14.698V10Zm5 9a2 2 0 1 0 4 0h-4Z" fill="currentColor"/></svg>`,
};
